import { TEACHER_DEPARTMENT_NAME } from './constants';

// Which department a reminder files under, given who is on it. The assignee owns the
// reminder so their department wins; otherwise the first observer who has one, then the
// creator's. Returns '' when nobody on the reminder has a department to offer.
//
// Teachers hold no department of their own, so every teacher-owned reminder files under
// the one named TEACHER_DEPARTMENT_NAME, looked up by name because the uuid differs per
// environment.
export const derive_department_uuid = ({
  assignee_uuid,
  observer_uuids,
  member_by_uuid,
  departments,
  self_uuid
}) => {
  if (assignee_uuid) {
    return (departments || []).find((d) => d.name === TEACHER_DEPARTMENT_NAME)?.uuid || '';
  }
  const observer = (observer_uuids || [])
    .map((uuid) => member_by_uuid(uuid))
    .find((m) => m?.department_uuid);
  return observer?.department_uuid || member_by_uuid(self_uuid)?.department_uuid || '';
};
